document.addEventListener('DOMContentLoaded', ()=>{
  const hook = setInterval(()=>{
    let formDiv = document.querySelector('.pxFormGenerator');
    if (formDiv && typeof window.GetCorePage === 'function'){
      clearInterval(hook);
      window.GetCorePage();
    }
  },150)
    setTimeout(()=>{
      clearInterval(hook);
    },10000)
});